import { IStorageSessionCredentials } from '@gem/modules/remote-storage';

import { StorageSessionCredentials } from 'APP/wsApi/wsAppApi/types/upload/upload_responses_pb';

export function mapStorageSessionCredentialsResponse(
  data: StorageSessionCredentials
): IStorageSessionCredentials {
  return {
    accessKeyId: data.accessKeyId || '',
    secretAccessKey: data.secretAccessKey || '',
    serviceName: data.serviceName || '',
    sessionToken: data.sessionToken || '',
    endpoint: data.endpoint || '',
    region: data.region || '',
    expiration: data.expiration || '',
  };
}
